import React, { useContext, useState } from "react";

const FilterContext = React.createContext();

export function useFilter() {
	return useContext(FilterContext);
}

export function FilterProvider({ children }) {
	const [selectedOptions, setSelectedOptions] = useState([]);
	const [optionType, setOptionType] = useState(1);
	const [step1Car, setStep1Car] = useState(1);
	const [step2Car, setStep2Car] = useState(0);
	const [selectedQuotation, setSelectedQuotation] = useState(null);
	const [step, setStep] = useState(0);

	const [carData, setCarData] = useState(null);

	const resetFilters = () => {
		setSelectedOptions([]);
		setOptionType(1);
		setStep1Car(0);
		setStep2Car(0);
		setStep(0);
		setSelectedQuotation(null);
		setCarData(null);
	};

	const value = {
		selectedOptions,
		setSelectedOptions,
		optionType,
		setOptionType,
		step1Car,
		setStep1Car,
		carData,
		setCarData,
		selectedQuotation,
		setSelectedQuotation,
		resetFilters,
		step2Car,
		setStep2Car,
		step,
		setStep,
	};
	return (
		<FilterContext.Provider value={value}>{children}</FilterContext.Provider>
	);
}
